import type { Media } from "@/features/dashboard/types/media";
import { IconPaperclip, IconX } from "@tabler/icons-react";
import clsx from "clsx";
import * as React from "react";
import { Button } from "../buttons/button";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	setFile?: (file: File | null) => void;
	removeUploadedFile?: (file: Media | null) => void;
	uploadedFile?: Media | null;
}

const InputFile = React.forwardRef<HTMLInputElement, InputProps>(({ className, setFile, uploadedFile, removeUploadedFile, ...props }, ref) => {
	const [localFile, setLocalFile] = React.useState<File | null>(null);
	const [localUploadedFile, setLocalUploadedFile] = React.useState<Media | null>(uploadedFile || null);
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (setFile) {
			setFile(e.target.files?.[0] || null);
		}
		setLocalFile(e.target.files?.[0] || null);

		if (props.onChange) {
			return props.onChange(e);
		}
	};

	const resetLocalFile = () => {
		setLocalFile(null);
		setFile(null);
	};

	const handleRemoveUploadedFile = () => {
		console.log("remove uploaded");
		setLocalUploadedFile(null);

		if (removeUploadedFile) {
			return removeUploadedFile(null);
		}
	};

	const RemoveButton = () => {
		return (
			<button type="button" className="bg-transparent text-foreground/30 hover:text-foreground">
				<IconX size={18} stroke={2} />
			</button>
		);
	};

	return (
		<>
			<div
				className={clsx(
					"flex flex-row w-full min-h-[38px] max-h-[38px] h-[38px] px-3 text-base rounded-md border-border border focus-within:border-focus-border focus-within:ring-2 ring-offset-0 focus-within:ring-focus-ring/30 outline-0",
					{
						"bg-muted text-muted-foreground": props.disabled,
						"bg-background text-foreground": !props.disabled,
					},
					className,
				)}
			>
				<div className="flex flex-row items-center w-full gap-1 pointer-events-none">
					<IconPaperclip className="text-muted-foreground" size={18} stroke={1.5} />
					<span className="text-muted-foreground">{localUploadedFile?.file_name ? localUploadedFile.file_name : localFile?.name || "No file chosen"}</span>
				</div>
				<input type="file" className="absolute inset-0 block w-full h-full p-0 m-0 opacity-0" ref={ref} {...props} onChange={handleChange} />
				{localUploadedFile && (
					// <Button className="absolute right-0 top-0 bottom-0 inline-flex justify-center items-center px-3" onClick={handleRemoveUploadedFile}>
					// 	<RemoveButton />
					// </Button>

					<div className="absolute right-0 top-0 bottom-0 inline-flex justify-center items-center px-3">
						<button type="button" onClick={handleRemoveUploadedFile} className="bg-transparent text-foreground/30 hover:text-foreground">
							<IconX size={18} stroke={2} />
						</button>
					</div>
				)}
				{localFile?.name && (
					// <Button className="absolute right-0 top-0 bottom-0 inline-flex justify-center items-center px-3" onClick={resetLocalFile}>
					// 	<RemoveButton />
					// </Button>
					<div className="absolute right-0 top-0 bottom-0 inline-flex justify-center items-center px-3">
						<button type="button" onClick={resetLocalFile} className="bg-transparent text-foreground/30 hover:text-foreground">
							<IconX size={18} stroke={2} />
						</button>
					</div>
				)}
			</div>
		</>
	);
});
InputFile.displayName = "InputFile";

export { InputFile };
